import classNames from 'clsx';
import type React from 'react';
import { memo } from 'react';
import type { CellProps } from 'react-table';

import CashedIcon from '../../../assets/icons/player-state/cashed-icon.svg';
import FinishedIcon from '../../../assets/icons/player-state/finished-icon.svg';
import PlayingIcon from '../../../assets/icons/player-state/playing-icon.svg';
import RegisteredIcon from '../../../assets/icons/player-state/registered-icon.svg';
import { PlayerState, type Tournament } from '../../../types/MTT';

import styles from './TableCellPlayerState.scss';

type Props = CellProps<Tournament>;

const TableCellPlayerState: React.FC<Props> = memo((props) => {
  const { value } = props;
  const handlePlayerState = () => {
    switch (value) {
      case PlayerState.REGISTERED:
        return <RegisteredIcon />;
      case PlayerState.RUNNING:
        return <PlayingIcon />;
      case PlayerState.COMPLETED_AND_PLAYER_CASHED:
        return <CashedIcon />;
      case PlayerState.COMPLETED_NOT_CASH:
        return <FinishedIcon />;
      default:
        return null;
    }
  };

  return (
    <div
      className={classNames(styles.iconWrapper, {
        [styles.iconWrapperRegistered]: value === PlayerState.REGISTERED
      })}
    >
      {handlePlayerState()}
    </div>
  );
});

export default TableCellPlayerState;
